import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from './Login';
import ContentcreationRefactored from './ContentcreationRefactored';
import ContentBankDashboard from './ContentBankDashboard';
import ContentBank from './components/ContentBank';
import ProjectContentBank from './components/ProjectContentBank';
import CodingQuestions from './components/CodingQuestions';
import HTMLCSSEditor from './pages/HTMLCSSEditor';
import ProjectConfiguration from './Project-components/ProjectConfiguration.tsx';
import MasterPage from './pages/MasterPage';
import McqTestingPage from './pages/McqTestingPage';
import RequireAuth from './components/RequireAuth';
import { AppShellLayout } from './layout';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/coding-web" element={<HTMLCSSEditor />} />
      <Route element={<AppShellLayout />}>
        <Route path="/dashboard" element={<ContentBankDashboard />} />
        <Route path="/master" element={<MasterPage />} />
        <Route path="/content-creation" element={<ContentcreationRefactored />} />
        <Route path="/content-bank" element={<ContentBank />} />
        <Route path="/project-content" element={<ProjectContentBank />} />
        <Route path="/project-configuration" element={<ProjectConfiguration />} />
        <Route path="/coding-questions" element={<CodingQuestions />} />
        <Route
          path="/testing/mcq/:subjectId/:verified"
          element={
            <RequireAuth>
              <McqTestingPage routeQuestionType="mcq" />
            </RequireAuth>
          }
        />
        <Route
          path="/testing/quiz/:subjectId/:verified"
          element={
            <RequireAuth>
              <McqTestingPage routeQuestionType="quiz" />
            </RequireAuth>
          }
        />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
